import '@adornis/chemistry/elements/components/x-flex.js';
import { XFormFieldWrapper } from '@adornis/chemistry/elements/components/x-formfield-wrapper.js';
import { inputToken } from '@adornis/chemistry/elements/theming/input-token.js';
import { customElement, property } from 'lit/decorators.js';
import './tr-tooltip.js';

/**
 * @element tr-formfield-wrapper
 */
@customElement('tr-formfield-wrapper')
export class TrFormfieldWrapper extends XFormFieldWrapper {
  @property({ reflect: true, attribute: 'placeholder-mode' }) override placeholderMode:
    | 'inline-floating'
    | 'floating'
    | 'prefix'
    | 'hide'
    | 'static-floating' = 'static-floating';

  override get inputToken() {
    const token = inputToken(this);
    token.borderRadius = this.sizes.borderRadiusSecondary;
    // token.border = '1px solid rgba(128,127,128,.3)';
    token.border = 'none';
    // same default as before, but overridable from outside the shadow DOM via CSS
    // variable (matches the chemistry x-formfield-wrapper convention)
    token.backgroundColor = `var(--color-base-200, ${this.colors.neutral.shade(50)})` as any;
    token.padding = '.9375rem .625rem !important';
    // token.boxShadow = 'inset 0 0 2px rgb(128 127 128 / 30%)';
    return token;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': { borderRadius: '20px' },
        ':host(:not([disabled])) [background]:hover, :host [background]:focus-within': {
          // boxShadow: '0 0 2px rgb(128 127 128) !important',
          background: this.transparent ? 'transparent' : `var(--color-base-300, ${this.colors.neutral.shade(100)})`,
        },
        ':host [background]': {
          height: !this.multiLine
            ? `calc(${this.baseFontSize}px + ${this.inputToken.paddingTop!} + ${this.inputToken.paddingBottom!} + 8px)`
            : 'auto',
          border: 'none',
        },
        ':host([disabled])': {
          opacity: '0.5',
          pointerEvents: 'none',
          cursor: 'not-allowed',
        },
        ':host([error]) [background]': {
          border: `1px solid ${this.colors.tone.error}`,
          background: this.colors.tone.snowWhite,
        },
        ...(this.info && !this.icon ? { 'tr-icon': { color: this.colors.neutral.shade(100) } } : {}),
      },
    ] as any;
  }
}
